import { ConfirmResetStore } from '../ConfirmResetStore';

export const SetPassword = async (location) => {
    {
        location === '/resetpassword' ? ConfirmResetStore.validatePassword() : ConfirmResetStore.confirmSetPassword();
    }
};
